import React, {Component} from 'react';
import {Layout, Breadcrumb} from 'antd';
import { Table } from 'antd';
import {inject, observer} from "mobx-react";
import * as mobx from 'mobx';
import NumberFormat from 'react-number-format';
import styles from './styles.module.css';

const {Content} = Layout;

class TopList extends Component {

  fixSymbolIcon(s) {
    let retval;
    switch(s) {
      case "MIOTA":
        retval = 'IOTA-alt';
      break;
      case 'BTG':
        retval = 'BTC';
      break;
      case 'XLM':
        retval = 'STR';
      break;
      default:
        retval = s;
    }
    return retval;
  }

  componentWillMount() {
    this._mounted = true;
    this._checker = setInterval(this.checker, 15000);
  }

  componentWillUnmount() {
    this._mounted = false;
    clearInterval(this._checker);
    this._checker = null;
  }

  checker = () => {
    this.props.main.fetchMarketTop10();
  }

  renderTop10Table() {
    const cls = (text) => {
      return {className: text > 0 ? 'xup' : 'xdown'}
    }
    const columns = [{
      title: '#',
      dataIndex: 'rank',
      fixed: 'left'
    },{
      title: 'Name',
      dataIndex: 'name',
      render: (text, row, index) => text, //<Link to={'/market/asset/'+row['id']}>{text}</Link>,
      sorter: (a, b) => a.name[0].toLowerCase() > b.name[0].toLowerCase()
    },
    {
      title: 'Symbol',
      dataIndex: 'symbol',
      render: (text, row, index) => <span><i className={"cc "+this.fixSymbolIcon(row['symbol'])}></i> {text}</span>, //<Link to={'/market/asset/'+row['id']}><i className={"cc "+this.fixSymbolIcon(row['symbol'])}></i> {text}</Link>,
      sorter: (a, b) => a.symbol[0].toLowerCase() > b.symbol[0].toLowerCase()
    },
      {
      title: 'Price',
      dataIndex: 'price_usd',
      render: (text, row, index) => {
        return <NumberFormat displayType="text" value={text} thousandSeparator={true} prefix={'$'} />
      },
      sorter: (a, b) => a.price_usd - b.price_usd
    },{
      title: '1h',
      dataIndex: 'percent_change_1h',
      render: (text, row, index) => {
        return <NumberFormat displayType="text" value={text} suffix={'%'} {...cls(text)} />
      },
      sorter: (a, b) => a.percent_change_1h - b.percent_change_1h
    }, {
      title: '24h',
      dataIndex: 'percent_change_24h',
      render: (text, row, index) => {
        return <NumberFormat displayType="text" value={text} suffix={'%'} {...cls(text)} />
      },
      sorter: (a, b) => a.percent_change_24h - b.percent_change_24h
    }, {
      title: '7d',
      dataIndex: 'percent_change_7d',
      render: (text, row, index) => {
        return <NumberFormat displayType="text" value={text} suffix={'%'} {...cls(text)} />
      },
      sorter: (a, b) => a.percent_change_7d - b.percent_change_7d
    },{
      title: 'Market Cap',
      dataIndex: 'market_cap_usd',
      render: (text, row, index) => {
        return <NumberFormat displayType="text" value={text} decimalScale={0} thousandSeparator={true} prefix={'$'} />
      },
      sorter: (a, b) => a.market_cap_usd - b.market_cap_usd,
      defaultSortOrder: 'descend'
    },{
      title: 'Volume 24h',
      dataIndex: '24h_volume_usd',
      render: (text, row, index) => {
        return <NumberFormat displayType="text" value={text} decimalScale={0} thousandSeparator={true} prefix={'$'} />
      },
      sorter: (a, b) => a['24h_volume_usd'] - b['24h_volume_usd']
    }, {
      title: 'Circulating Supply',
      dataIndex: 'available_supply',
      render: (text, row, index) => {
        return <NumberFormat displayType="text" value={text} decimalScale={0} thousandSeparator={true} />
      },
      sorter: (a, b) => a.available_supply - b.available_supply
    }];
    return (
      <Table
        columns={columns}
        dataSource={mobx.toJS(this.props.main.marketTop10)}
        rowKey="id"
        pagination={false}
        loading={mobx.toJS(this.props.main.marketTop10).length === 0}
        scroll={{ x: 1070 }}
        footer={()=><span className={styles.footer}>This page refreshes automatically</span>}
      />
    )
  }

  render() {
    return(
      <Content>
        <Breadcrumb style={{
            margin: '1em 2em'
          }}>
          <Breadcrumb.Item>The Market</Breadcrumb.Item>
          <Breadcrumb.Item>Top 20 Coins</Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.main}>
          <h2>Top Cryptocurrencies</h2>
          {this.renderTop10Table()}
        </div>
      </Content>);
  }
}

export default inject("main")(observer(TopList));



// WEBPACK FOOTER //
// ./src/containers/TopList/TopList.js